import PropTypes from 'prop-types';

const Label = ({ type, text, marginLeft }) => {
  let color;
  switch (type) {
    case 'red':
      color = '#950810';
      break;
    case 'blue':
      color = '#4A90E2';
      break;
    case 'grey':
      color = '#646464';
      break;
    case 'orange':
      color = '#C44700';
      break;
    case 'green':
      color = '#509508';
      break;
    case 'yellow':
      color = '#C49000';
      break;
    default:
      color = '#950810';
  }
  return (
    <>
      <span className="label">{text.toUpperCase()}</span>
      <style jsx>
        {`
          .label {
            margin-left: ${marginLeft};
            height: 16px;
            background-color: ${color};
            font-size: 10px;
            font-weight: 500;
            letter-spacing: 0;
            line-height: 16px;
            border-radius: 2px;
            padding: 3px 6px;
            white-space: nowrap;
          }
        `}
      </style>
    </>
  );
};

Label.propTypes = {
  type: PropTypes.oneOf(['red', 'blue', 'grey', 'orange', 'green', 'yellow']),
  text: PropTypes.string.isRequired,
  marginLeft: PropTypes.string,
};

Label.defaultProps = {
  type: 'red',
  marginLeft: '6px',
};
export default Label;
